
const getters = {
  getCities (store) {
    return store.cities;
  },
  getIsSelectCountry (store) {
    return store.isSelectCountry
  },
  getCountry (store) {
    return store.country
  },
  getCountries (store) {
    return store.countries
  }
}

export default getters
